import { GlobalDragOverlay } from './global-drag-overlay';
import { AttachFileDialog } from './attach-file-dialog';
import { MobileNav } from './mobile-nav';
import { TaskBulkActions, ListBulkActions } from './bulk-actions';
export function OverlaysSection({
  isMobile,
  isGlobalDragging,
  isOverTask,
  isTaskSelectorOpen,
  setIsTaskSelectorOpen,
  droppedFiles,
  todos,
  handleAttachTodoSelect,
  handleCancelAttach,
  activeTab,
  handleMobileNavSelect,
  selectedIds,
  handleBulkCompleteClick,
  bulkDuplicate,
  bulkDelete,
  handleClearSelectedIds,
  selectedListIds,
  bulkDuplicateLists,
  bulkDeleteLists,
  handleClearSelectedListIds,
  handleToggleSidebar
}) {
  return <>
      <GlobalDragOverlay isDragging={isGlobalDragging} isOverTask={isOverTask} />

      <AttachFileDialog isOpen={isTaskSelectorOpen} onOpenChange={setIsTaskSelectorOpen} droppedFiles={droppedFiles} todos={todos} onSelectTodo={handleAttachTodoSelect} onCancel={handleCancelAttach} />

      {isMobile ? <MobileNav activeTab={activeTab} onSelect={handleMobileNavSelect} onToggleSidebar={handleToggleSidebar} selectedIds={selectedIds} todos={todos} onBulkComplete={handleBulkCompleteClick} onBulkDuplicate={bulkDuplicate} onBulkDelete={bulkDelete} onClearSelection={handleClearSelectedIds} selectedListCount={selectedListIds.size} onBulkDuplicateLists={bulkDuplicateLists} onBulkDeleteLists={bulkDeleteLists} onClearListSelection={handleClearSelectedListIds} /> : <>
          <TaskBulkActions selectedIds={selectedIds} todos={todos} onBulkComplete={handleBulkCompleteClick} onBulkDuplicate={bulkDuplicate} onBulkDelete={bulkDelete} onClearSelection={handleClearSelectedIds} />

          <ListBulkActions selectedCount={selectedListIds.size} onBulkDuplicate={bulkDuplicateLists} onBulkDelete={bulkDeleteLists} onClearSelection={handleClearSelectedListIds} />
        </>}
    </>;
}
